import { usePage } from "@tree-company/tree-query";
import { ShareSection } from "./share_section";
import { useLayoutEffect } from "react";
import Footer from "./footer";

export function ResultPage({ page }) {
  const { title } = usePage(page);

  const { profile } = page.treesponse.answers;

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <title>{title}</title>
      <ShareSection profile={profile} answers={page.treesponse.answers} />
      <Footer />
    </>
  );
}
